module.exports = __webpack_public_path__ + "fonts/NotoSans-SemiBold.ec6532d5.woff";